import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, Button, Col, Form, Image, InputGroup, Modal, Row, Table, Nav } from "react-bootstrap";
import Paginationnew from '../Uitiles/Paginationnew';
import { getuserdata } from '../services/apiService';
import { getMyDoctors } from '../controllers/Hosptals/MyDoctorsController';
import ImageShow from '../Uitiles/ImageShow';
import DoctorSpecialities from '../layouts/Frontend/Home/Components/DoctorSpecialities';
import { Select } from 'antd';
import { oneKlicks } from '../SDK/oneclick';
import { toast } from 'react-toastify';


const HospitalMyDoctors = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState('');
    const [filtered, setFiltered] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [hospital, setHospital] = useState({});
    const [editedata, setEditedata] = useState({});
    const [selectedDoctor, setSelectedDoctor] = useState({});

    const limit = 10;

    const handleDelete = async (doctorAssociation) => {
        // Show confirmation dialog
        const doctorName = doctorAssociation.doctors?.[0]?.display_name || 'this doctor';
        const confirmDelete = window.confirm(
            `Are you sure you want to remove Dr. ${doctorName} from your hospital?\n\nNote: This will only remove the association. The doctor's account will not be deleted.`
        );

        if (!confirmDelete) {
            return;
        }

        try {
            setLoading(true);

            // Delete from hospital_doctors table
            const tableSchema = "";
            const tableName = "hospital_doctors";
            const conditions = {
                id: doctorAssociation.id,
                hospital_id: hospital.id,
                doctor_id: doctorAssociation.doctor_id
            };

            console.log('Deleting doctor association:', conditions);

            const response = await oneKlicks.delete(tableSchema, tableName, conditions);

            console.log('Delete response:', response);

            if (response && response.success) {
                toast.success(`Dr. ${doctorName} has been removed from your hospital successfully!`);
                // Refresh the doctors list
                getMyDoctorsData();
            } else {
                toast.error('Failed to remove doctor. Please try again.');
                console.error('Delete failed:', response);
            }
        } catch (error) {
            console.error('Error deleting doctor association:', error);
            toast.error('An error occurred while removing the doctor.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getHospitalId();
        getMyDoctorsData();
    }, []);

    useEffect(() => {
        getMyDoctorsData();
    }, [page, limit, search, hospital]);


    const getHospitalId = async () => {
        const hospitalData = await getuserdata("full");
        console.log('GET HOSPITAL ID response:', hospitalData);
        setHospital(hospitalData);
    }

    const getMyDoctorsData = async () => {
        if (hospital.id) {
            const response = await getMyDoctors(hospital.id, page, limit);
            console.log('GET MY DOCTORS DATA response controller:', hospital);
            console.log('GET MY DOCTORS DATA response new coming here:', response);
            setData(response.data);
            setTotalPages(response.totalPages);
        } else {
            getHospitalId();
        }
    }


    const formatTime = (time) => {
        if (!time) return '';
        const hours = parseInt(time.substring(0, 2));
        const minutes = time.substring(2);
        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12;
        return `${formattedHours}:${minutes} ${period}`;
    };


    const handleUpdateStatus = async () => {
        console.log('UPDATE STATUS response:', editedata);

        const tableSchema = "";
        const tableName = "appointment_settings";
        const data = {
            status: editedata.status
        }
        const condition = {
            id: editedata.id
        }
        const updateStatus = await oneKlicks.update(tableSchema, tableName, data, condition);

        if (updateStatus.success === true) {
            const tableSchema = "";
            const tableName = "hospital_doctors";
            const data = {
                hospital_id: hospital.id,
                doctor_id: editedata.id,
                status: editedata.status
            }
            const condition = {
                doctor_id: selectedDoctor.id,
                hospital_id: hospital.id
            }
            const updateHospitalDoctors = await oneKlicks.update(tableSchema, tableName, data, condition);

            if (updateHospitalDoctors.success === true) {
                toast.success("Status updated successfully");
                setOpenView(false);
                getMyDoctorsData();
            } else {
                toast.error("Status update failed");
            }
        } else {
            toast.error("Status update failed");
        }
    }




    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">My Doctors</h5>
                                <Badge bg="info">Doctors</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </InputGroup>
                                <Button variant="primary" style={{ height: 50, width: 150 }} onClick={() => navigate('/hospital/adddoctor')}>+ Add Doctor</Button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Image</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Speciality</th>
                                        <th style={{ width: 120 }}>Status</th>
                                        <th style={{ width: 180 }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length === 0 && (
                                        <tr>
                                            <td colSpan={8} className="text-center text-muted py-4">No templates found.</td>
                                        </tr>
                                    )}
                                    {data.map((t) => {
                                        if (t.doctor_id === "") return null;
                                        console.log('GET MY DOCTORS DATA data new table coming here:', t);
                                        return (
                                            <tr key={t.id}>
                                                <td>#{t.id}</td>
                                                <td>
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <ImageShow url={t.doctors?.[0]?.profile_photo_url || "/uploads/3/doctors/1746963970092_default-placeholder-doctor-halflength-portrait-600nw-1058724875.png"} alt={t.doctors?.[0]?.display_name} width={30} height={30} style={{ borderRadius: 5 }} />
                                                    </div>
                                                </td>
                                                <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.doctors?.[0]?.display_name}</td>
                                                <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.doctors?.[0]?.email}</td>
                                                <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.doctors?.[0]?.phone}</td>
                                                <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    <DoctorSpecialities doctorId={t.doctors?.[0]?.id} data={t.doctors?.[0] || []} type="list" />
                                                </td>
                                                <td>
                                                    <span className={`badge ${t.status === 'Active' ? 'badge-success' : t.status === 'Pending' ? 'badge-warning' : 'badge-danger'}`} style={{ padding: "5px 10px" }}>
                                                        {t.status
                                                            ? t.status.charAt(0).toUpperCase() + t.status.slice(1)
                                                            : ''}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="d-flex" style={{ gap: 8 }}>
                                                        <Button size="sm" variant="outline-secondary" onClick={() => { setSelectedDoctor(t.doctors[0]); setOpenView(true); setEditedata(t) }}>View</Button>

                                                        <Button size="sm" variant="outline-danger" onClick={() => handleDelete(t)}>Delete</Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>

                        <Paginationnew
                            currentPage={page}
                            totalPages={totalPages}
                            handlePageChange={setPage}
                        />
                    </div>
                </div>

                {selectedDoctor && (
                    <Modal show={openView} onHide={() => setOpenView(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>View Doctor</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="d-flex justify-content-center align-items-center" style={{ gap: 10 }}>
                                <ImageShow url={selectedDoctor.profile_photo_url || "/uploads/3/doctors/1746963970092_default-placeholder-doctor-halflength-portrait-600nw-1058724875.png"} alt={selectedDoctor.display_name} width={150} height={150} style={{ borderRadius: 5 }} />
                                <div className="d-flex flex-column">
                                    <h5 style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedDoctor.display_name}</h5>
                                    <p style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedDoctor.email}</p>
                                    <p style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedDoctor.phone}</p>
                                    <p style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedDoctor.speciality}</p>
                                </div>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-center align-items-center" style={{ gap: 10, flexDirection: 'column' }}>
                                <h5>Weekly Schedule :</h5>
                                {(() => {
                                    let selectedDays = [];
                                    let dayTimeSlots = {};

                                    // Parse day-based time slots
                                    if (editedata.selected_days && editedata.day_time_slots) {
                                        try {
                                            selectedDays = JSON.parse(editedata.selected_days);
                                            dayTimeSlots = editedata.day_time_slots; // Already an object
                                        } catch (e) {
                                            console.error('Error parsing appointment data:', e);
                                            // Legacy support
                                            if (editedata.start_time && editedata.end_time) {
                                                selectedDays = ['mon', 'tue', 'wed', 'thu', 'fri'];
                                                selectedDays.forEach(day => {
                                                    dayTimeSlots[day] = [{
                                                        start_time: editedata.start_time,
                                                        end_time: editedata.end_time
                                                    }];
                                                });
                                            }
                                        }
                                    } else if (editedata.start_time && editedata.end_time) {
                                        // Legacy support
                                        selectedDays = ['mon', 'tue', 'wed', 'thu', 'fri'];
                                        selectedDays.forEach(day => {
                                            dayTimeSlots[day] = [{
                                                start_time: editedata.start_time,
                                                end_time: editedata.end_time
                                            }];
                                        });
                                    }

                                    const dayLabels = {
                                        'sun': 'Sunday',
                                        'mon': 'Monday',
                                        'tue': 'Tuesday',
                                        'wed': 'Wednesday',
                                        'thu': 'Thursday',
                                        'fri': 'Friday',
                                        'sat': 'Saturday'
                                    };

                                    // Show all 7 days of the week
                                    const allDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

                                    return allDays.map(day => (
                                        <div key={day} className="row justify-content-between" style={{ marginBottom: '10px', marginLeft: '0px', marginRight: '0px', width: '100%' }}>
                                            <div style={{ fontWeight: 'bold', marginBottom: '5px', width: '115px' }}>
                                                <i className="fa fa-calendar" style={{ marginRight: '5px' }}></i>
                                                {dayLabels[day]}
                                            </div>
                                            <div className="d-flex column" style={{ display: 'flex', gap: '20px', marginBottom: '3px', marginLeft: '20px', flexDirection: 'column', flex: 1 }}>
                                                {dayTimeSlots[day] && dayTimeSlots[day].length > 0 ? (
                                                    dayTimeSlots[day].map((slot, index) => (
                                                        <div key={index} className="d-flex column" style={{ display: 'flex', gap: '20px', marginBottom: '3px', marginLeft: '20px' }}>
                                                            {slot.start_time === 'closed' ? (
                                                                <span style={{ color: '#dc3545' }}>
                                                                    <i className="fa fa-times-circle" style={{ marginRight: '5px' }}></i>
                                                                    Closed
                                                                </span>
                                                            ) : slot.start_time === '0000' && slot.end_time === '2400' ? (
                                                                <span style={{ color: '#28a745' }}>
                                                                    <i className="fa fa-clock" style={{ marginRight: '5px' }}></i>
                                                                    24 Hours Open
                                                                </span>
                                                            ) : (
                                                                <>
                                                                    <div className="d-flex gap-2 pt-6" style={{ paddingTop: '6px' }}>
                                                                        <i className="fa fa-clock" style={{ marginRight: '5px' }}></i>
                                                                        <span>Start: {formatTime(slot.start_time)}</span>
                                                                    </div>
                                                                    <div className="d-flex gap-2 pt-6" style={{ paddingTop: '6px' }}>
                                                                        <i className="fa fa-clock" style={{ marginRight: '5px' }}></i>
                                                                        <span>End: {formatTime(slot.end_time)}</span>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div style={{ marginLeft: '20px' }}>
                                                        <span style={{ color: '#dc3545' }}>
                                                            <i className="fa fa-times-circle" style={{ marginRight: '5px' }}></i>
                                                            Closed
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ));
                                })()}
                            </div>
                            <hr />
                            <h5>Status :</h5>
                            <Select
                                placeholder="Select Status"
                                value={editedata.status}
                                style={{ width: '100%' }}
                                onChange={(value) => setEditedata({ ...editedata, status: value })}
                            >
                                <Select.Option value="Active">Active</Select.Option>
                                <Select.Option value="Pending">Pending</Select.Option>
                                <Select.Option value="Rejected">Rejected</Select.Option>
                            </Select>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setOpenView(false)}>Close</Button>
                            <Button variant="primary" onClick={() => handleUpdateStatus()}>Update</Button>
                        </Modal.Footer>
                    </Modal>
                )}

            </div>
        </div>
    );
};

export default HospitalMyDoctors;
